import { takeLatest, put, race, take } from 'redux-saga/effects';

import * as error from '../../ui/error';
import * as deleteDocument from '../requests/delete-document-req';

function* handleDeleteDocument({ payload: { appointmentId, documentId } }) {
  const { success } = yield race({
    success: take(deleteDocument.consts.SUCCEED),
    error: take(deleteDocument.consts.REJECTED),
  });

  if (success) {
    yield put(
      deleteDocument.actions.update({
        documentId,
        appointmentId,
      }),
    );
  } else {
    yield put({
      type: error.consts.UPDATE,
      payload: { id: 'errors.common' },
    });
  }
}

export default function* deleteDocumentSaga() {
  yield takeLatest(deleteDocument.actions.send, handleDeleteDocument);
}



// WEBPACK FOOTER //
// ./src/redux/healthboard/sagas/delete-document-saga.js